import React from 'react'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { ErrorView } from '../../error/ErrorView'
import { IllustrationChoices } from '../../../components/common/Illustration'
import { useAppTranslation } from '../../../hooks/useAppTranslation'
import { ButtonVariant } from '../../../components/common/Button'
import {
  CONSTANTS_SOCIETY_GUIDES,
  societyGuidesQueries,
  startGuide,
} from '../../../api/society-guides'
import { useCurrentSociety } from '../../../hooks/useCurrentSociety'
import { i18nSocietyType } from '../../../i18n'

export const StartGetToKnow = ({
  societyId,
}: {
  societyId: string
}): React.ReactNode => {
  const { translate } = useAppTranslation()
  const { society } = useCurrentSociety()
  const queryClient = useQueryClient()
  const { mutate, isPending } = useMutation({
    mutationFn: async () => {
      await startGuide({
        guideId: CONSTANTS_SOCIETY_GUIDES.GUIDE_ID.GET_TO_KNOW,
        societyId,
        completed: true,
      })
      await queryClient.invalidateQueries({
        queryKey: societyGuidesQueries.getToKnow(societyId).queryKey,
      })
    },
  })
  return (
    <ErrorView
      illustration={IllustrationChoices.CHECKLIST}
      title={translate('getToKnowScreen.startGuide.title')}
      subtitle={translate('getToKnowScreen.startGuide.description', {
        context: i18nSocietyType(society?.societyTypeDisplayName),
      })}
      buttons={[
        {
          id: 'startGuide',
          button: {
            label: translate('getToKnowScreen.startGuide.button'),
            variant: ButtonVariant.PRIMARY,
            loading: isPending,
            onClick: () => {
              mutate()
            },
          },
        },
      ]}
    />
  )
}
